import { SetorModel } from './../models/setor-model';
import { GrupoModel } from './../models/grupo-model';
import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { EmpresaModel } from '../models/empresa-model';
import { Funcoes, Periodos } from '../services/funcoes';
import { Services } from '../services/servicos';
import { ComercialModel } from './comercial-model';

@Component({
  selector: 'app-comercial',
  templateUrl: './comercial.component.html',
  styleUrls: ['./comercial.component.css']
})
export class ComercialComponent implements OnInit {
//DECLARAÇÕES
funcoes: Funcoes = new Funcoes();
//
//INI VARIÁVES
empresas: EmpresaModel[];
selecionarEmpresa: EmpresaModel;

setores: SetorModel[];
selecionarSetores: SetorModel;

grupos: GrupoModel[];
selecionarGrupo: GrupoModel;

periodos: Periodos[];
selecionarPeriodo: string;

data_inicial: Date = new Date();
data_final: Date = new Date();
grafico: any;
grafico_bar: any;


lista: ComercialModel[];
currentUser = JSON.parse(localStorage.getItem('currentUser'));
total: number
loading: boolean = true;
filtros: ComercialModel = new ComercialModel();

//A - Total orçamento
listaGeral: ComercialModel[];
listaTotalOrcamento: ComercialModel[];
totalTotalOrcamento: number
displayTotalOrcamento: boolean;
//B - Orçamentos aprovados
listaOrcamentosAprovados: ComercialModel[];
totalOrcamentosAprovados: number
displayOrcamentosAprovados: boolean;
//C - Orçamentos em negociação
listaOrcamentosNegociacao: ComercialModel[];
totalOrcamentosNegociacao: number
displayOrcamentosNegociacao: boolean;
//D - Orçamentos em negociação geral
listaOrcamentosNegociacaoGeral: ComercialModel[];
totalOrcamentosNegociacaoGeral: number
displayOrcamentosNegociacaoGeral: boolean;
//E - Orçamentos perdidos
listaOrcamentosPerdidos: ComercialModel[];
totalOrcamentosPerdidos: number
displayOrcamentosPerdidos: boolean;
//FIM VARIÁVEIS

constructor(private service: Services,
  private messageService: MessageService,
  private confirmationService: ConfirmationService,
  private config: PrimeNGConfig) {

  this.periodos = this.funcoes.Periodos;
  if (this.periodos.length > 0) {
    this.selecionaMesAtual();
  }
  //this.origens = this.funcoes.Origens;
}

selecionaMesAtual() {
  var today = new Date();
  var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  this.selecionarPeriodo = this.periodos.find(c => c.cod == mm).nome;
  console.log(this.selecionarPeriodo);
  this.selecionaPeriodo(this.selecionarPeriodo);

  //const dtEsp: Date = new Date(1970, 1, 1)
}

ngOnInit(): void {

  this.config.setTranslation({
    accept: 'Aceitar',
    reject: 'Cancelar',
    dayNames: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
    dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"], 
    dayNamesMin: ["Do", "Se", "Te", "Qu", "Qu", "Se", "Sa"],
    monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
    monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
    today: 'Hoje',
    clear: 'Limpar'
    //translations
  });

  //BUSCANDO EMPRESAS
  try {
    this.service.listarEmpresas()
      .subscribe(data => {
        if (data.Success) {
          this.empresas = data.Response;
        }
      },
        err => console.error(err)
      );
  }
  catch (e) {
    alert(e);
  }
  //BUSCANDO EMPRESAS

  //BUSCANDO SETOR
  try {
    this.service.listarSetor()
      .subscribe(data => {
        if (data.Success) {
          this.setores = data.Response;
        }
      },
        err => console.error(err)
      );
  }
  catch (e) {
    alert(e);
  }
  //FIM BUSCANDO SETOR

   //BUSCANDO GRUPO
   try {
    this.service.listarGrupo()
      .subscribe(data => {
        if (data.Success) {
          this.grupos = data.Response;
        }
      },
        err => console.error(err)
      );
  }
  catch (e) {
    alert(e);
  }
  //FIM BUSCANDO GRUPO

  this.selecionaMesAtual();
  //PESQUISANDO AO ABRIR
  this.pesquisar();
}
pesquisar() {
  this.loading = true;

  this.filtros.filtro_data_inicial = this.data_inicial;
  this.filtros.filtro_data_final = this.data_final;
  this.filtros.coligada = this.selecionarEmpresa == null ? "" : this.selecionarEmpresa.nome_fantasia;
  this.filtros.setor = this.selecionarSetores == null ? "" : this.selecionarSetores.nome;
  this.filtros.grupo = this.selecionarGrupo == null ? "" : this.selecionarGrupo.nome;
  console.log(this.filtros)
  try {
    this.service.listarComercial(this.filtros)
      .subscribe(data => {
        if (data.Success) {
          this.lista = data.Response;
          this.total = this.lista.length;
          this.loading = false;
           this.updateChart(data.Response);

        }
      },
        err => console.error(err)
      );
  }
  catch (e) {
    alert(e);
  }
}

onRowSelect(event) {

  try {
    this.service.listarComercialOrigem(this.filtros)
      .subscribe(data => {
        if (data.Success) {
          this.listaGeral = data.Response;
          var today = new Date();
          if (event.data.descricaoTitulo == "A - Total orçamento") {
              this.displayTotalOrcamento = true;
              this.listaTotalOrcamento = this.listaGeral;
              this.totalTotalOrcamento = this.listaTotalOrcamento.length;
            }
            else if (event.data.descricaoTitulo == "B - Orçamentos aprovados") {
              this.displayOrcamentosAprovados = true;
              this.listaOrcamentosAprovados = this.listaGeral.filter(c => c.situacao == "Aprovada" && new Date(c.aprovacao) >= new Date(this.filtros.filtro_data_inicial) && new Date(c.aprovacao) < today);
              this.totalOrcamentosAprovados = this.listaOrcamentosAprovados.length;
            }
            else if (event.data.descricaoTitulo == "C - Orçamentos em negociação") {
              this.displayOrcamentosNegociacao = true;
              this.listaOrcamentosNegociacao = this.listaGeral.filter(c => c.situacao == "Negociação" && new Date(c.data) >= new Date(this.filtros.filtro_data_inicial) && new Date(c.data) < today);
              this.totalOrcamentosNegociacao = this.listaOrcamentosNegociacao.length;
            }
            else if (event.data.descricaoTitulo == "D - Orçamentos em negociação geral") {
              this.displayOrcamentosNegociacaoGeral = true;
              this.listaOrcamentosNegociacaoGeral = this.listaGeral.filter(c => c.situacao == "Negociação" && new Date(c.data) >= new Date(this.filtros.filtro_data_inicial) && new Date(c.data) < today);
              this.totalOrcamentosNegociacaoGeral = this.listaOrcamentosNegociacaoGeral.length;
            }
            else if (event.data.descricaoTitulo == "E - Orçamentos perdidos") {
              this.displayOrcamentosPerdidos = true;
              this.listaOrcamentosPerdidos = this.listaGeral.filter(c => c.situacao == "Perdida" && new Date(c.data) >= new Date(this.filtros.filtro_data_inicial) && new Date(c.data) < today);
              this.totalOrcamentosPerdidos = this.listaOrcamentosPerdidos.length;
            }
        }
      },
        err => console.error(err)
      );
  }
  catch (e) {
    alert(e);
  }
}

comparandoDatasTitulosVencer(vencimento: Date) {
  var today = new Date();
  var DataVencimento = new Date(vencimento);
  console.log(DataVencimento);
  console.log(today);

  return (DataVencimento > today);
}

updateChart(chart: ComercialModel[]) {

  this.grafico = {
    labels: [
      'B - Orçamentos aprovados',
      'C - Orçamentos em negociação',
      'D - Orçamentos em negociação geral',
      'E - Orçamentos perdidos'],
    datasets: [
      {
        data: [chart[1].total_dinheiro, chart[2].total_dinheiro, chart[3].total_dinheiro, chart[4].total_dinheiro],
        backgroundColor: [
          "#FF6384",
          "#36A2EB",
          "#9ACD32",
          "#b01ea9",
        ],
        hoverBackgroundColor: [
          "#FF6384",
          "#36A2EB",
          "#9ACD32",
          "#b01ea9",
        ]
      }]
  };
}

onChangePeriodo(event) {
  if (event.value != null) {
    this.selecionaPeriodo(event.value);
    console.log(event);
  }
}

selecionaPeriodo(mes: string) {
  console.log('LOKOOOOO' + mes);
  if (mes == "Todos") {
    this.data_inicial = new Date(1950, 1, 1);
    this.data_final = new Date();
  }
  else if (mes == "3 Meses") {
    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 111));
    this.data_final = new Date();
    console.log((today.getDay() - 90));
    console.log(today);
    console.log(this.data_inicial);
  }
  else if (mes == "6 Meses") {

    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 201));
    this.data_final = new Date();
    console.log((today.getDay() - 180));
    console.log(today);
    console.log(this.data_inicial);
  }
  else if (mes == "9 Meses") {
    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 291));
    this.data_final = new Date();
    console.log((today.getDay() - 270));
    console.log(today);
    console.log(this.data_inicial);
  }
  else if (mes == "1 Ano") {

    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 386));
    this.data_final = new Date();
    console.log((today.getDay() - 365));
    console.log(today);
    console.log(this.data_inicial);
  }
  else if (mes == "Janeiro") {

    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), 0, 1);
    var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
    this.data_final = ultimoDia;
    console.log(ultimoDia.getDate());
  }
  else if (mes == "Fevereiro") {

    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), 1, 1);
    var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
    this.data_final = ultimoDia;
    console.log(ultimoDia.getDate());
  }
  else if (mes == "Março") {
    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), 2, 1);
    var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
    this.data_final = ultimoDia;
    console.log(ultimoDia.getDate());
  }
  else if (mes == "Abril") {
    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), 3, 1);
    var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
    this.data_final = ultimoDia;
    console.log(ultimoDia.getDate());
  }
  else if (mes == "Maio") {
    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), 4, 1);
    var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
    this.data_final = ultimoDia;
    console.log(ultimoDia.getDate());
  }
  else if (mes == "Junho") {
    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), 5, 1);
    var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
    this.data_final = ultimoDia;
    console.log(ultimoDia.getDate());
  }
  else if (mes == "Julho") {
    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), 6, 1);
    var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
    this.data_final = ultimoDia;
    console.log(ultimoDia.getDate());
  }
  else if (mes == "Agosto") {
    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), 7, 1);
    var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
    this.data_final = ultimoDia;
    console.log(ultimoDia.getDate());
  }
  else if (mes == "Setembro") {
    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), 8, 1);
    var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
    this.data_final = ultimoDia;
    console.log(ultimoDia.getDate());
  }
  else if (mes == "Outubro") {
    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), 9, 1);
    var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
    this.data_final = ultimoDia;
    console.log(ultimoDia.getDate());
  }
  else if (mes == "Novembro") {
    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), 10, 1);
    var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
    this.data_final = ultimoDia;
    console.log(ultimoDia.getDate());
  }
  else if (mes == "Dezembro") {
    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), 11, 1);
    var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
    this.data_final = ultimoDia;
    console.log(ultimoDia.getDate());
  }
}

}
